import React, {PropTypes} from 'react';
import moment from 'moment';
import DisplayIf from 'shared/DisplayIf.jsx';

const mdyyyyDateFormat = 'M/D/YYYY';

const TournamentList = ({
  entries,
  onManageClick,
  onCopyClick,
  groupName,
  isAllowed
}) => (
  <div className="list-group">
    {
      entries.map((item, index) => (
        item.userCanManage && window.GROUP_ENABLED === "true"
        ? <div key={index} className="list-group-item hover-highlight">
            <div className="list-group-item-inner-wrapper cursor-pointer" onClick={() => onManageClick(item.id)}>
              <h4 className="list-group-item-heading">
                <i className="fa fa-pencil" />
                {` `}
                {item.name}
                {item.readOnly ? ' (read-only)' : null}
              </h4>
            </div>
            <p className="list-group-item-text">              
              <div className="bg-light clearfix">
                <div className="pull-left">
                  {`Starts: ${moment.parseZone(item.startDate).format(mdyyyyDateFormat)}, Ends: ${moment.parseZone(item.endDate).format(mdyyyyDateFormat)}, Reg. Close Date: ${moment.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)}`}
                </div>
                <DisplayIf condition={isAllowed && groupName && window.GROUP_ENABLED === "true" ? true : false}>
                  <div className="pull-right cursor-pointer">
                    <button onClick={() => onCopyClick(item.id)}>
                      <i className="fa fa-copy" />{` Copy`}
                    </button>
                  </div>
                </DisplayIf>
              </div>
            </p>
          </div>
        : (item.userCanManage
        ? <div key={index} className="list-group-item hover-highlight">
            <div className="list-group-item-inner-wrapper cursor-pointer" onClick={() => onManageClick(item.id)}>
              <h4 className="list-group-item-heading">
                <i className="fa fa-pencil" />
                {` `}
                {item.name}
                {item.readOnly ? ' (read-only)' : null}
              </h4>
            </div>
            <p className="list-group-item-text">              
              <div className="bg-light clearfix">
                <div className="pull-left">
                  {`Starts: ${moment.parseZone(item.startDate).format(mdyyyyDateFormat)}, Ends: ${moment.parseZone(item.endDate).format(mdyyyyDateFormat)}, Reg. Close Date: ${moment.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)}`}
                </div>
              </div>
            </p>
          </div>
        : <div key={index} className="list-group-item highlight-disabled">
            <div className="list-group-item-inner-wrapper">
              <h4 className="list-group-item-heading">
                {item.name}{item.readOnly ? ' (read-only)' : null}
              </h4>
            </div>
            <p className="list-group-item-text">
              {`Starts: ${moment.parseZone(item.startDate).format(mdyyyyDateFormat)}, Ends: ${moment.parseZone(item.endDate).format(mdyyyyDateFormat)}, Reg. Close Date: ${moment.parseZone(item.registrationCloseDate).format(mdyyyyDateFormat)}`}
            </p>            
          </div>)
      ))
    }
  </div>
);

TournamentList.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object),
  onManageClick: PropTypes.func,
  onCopyClick: PropTypes.func
};

TournamentList.defaultProps = {
  entries: []
};

export default TournamentList;



// WEBPACK FOOTER //
// ./src/features/tournament/tournamentList/TournamentList.jsx